import { Container } from "../state/types";
import { Entity } from "../state/entity";
import { StatusCode } from "./ajax/statusCode";
import { create, delete$, retrieve, retrieveCollection, update } from "./rest/restEndpoint";
import { AjaxResponse } from "./ajax/types";

interface EndpointRequest
{

    data: Entity;

    readonly headers: Container;
    readonly body: Container;
}

interface EndpointResponse
{

    readonly data: Container;

    readonly succeeded: boolean;
    readonly status: StatusCode;
}

type EndpointResponseFactory =
    (ajax: AjaxResponse) => EndpointResponse;

type EndpointCall = Promise<EndpointResponse>;

interface EndpointCallFactory
{
    (): EndpointCall
}

export
{
    create,
    retrieve,
    retrieveCollection,
    update,
    delete$,
    EndpointCall,
    EndpointCallFactory,
    EndpointRequest,
    EndpointResponse,
    EndpointResponseFactory
}
